import Box from "@vapor/react-material/Box";

export const CodeBox = ({ sx, children }) => {
  return (
    <Box
      sx={{
        ...sx,
        background: "#eee",
        border: "1px solid #ddd",
        padding: "1px 10px",
        mt: 1,
        borderRadius: 1
      }}
    >
      <pre>{children}</pre>
    </Box>
  );
};
